export const objectifyArray = <T extends Record<string, any>>(idKey: string, array: T[]): Record<string, T> => {
  return array.reduce<Record<string, T>>((stack, next) => {
    stack[next[idKey]] = next;

    return stack;
  }, {});
};
